<script setup>
import { ref, onMounted, onBeforeUnmount, watch } from "vue";
import { useElementVisibility } from "@vueuse/core";

const props = defineProps({
  src: { type: String, required: true },
  margin: { type: String, default: "0px 0px 300px 0px" },
  loop: { type: Boolean, default: true },
  autoplay: { type: Boolean, default: false },
  renderer: { type: String, default: "svg" },
});

const container = ref(null);
let anim;

onMounted(() => {
  const isVisible = useElementVisibility(container, { rootMargin: props.margin });

  watch(
    isVisible,
    async (visible) => {
      if (visible && !anim) {
        const lottie = (await import("lottie-web")).default;
        anim = lottie.loadAnimation({
          container: container.value,
          renderer: props.renderer,
          loop: props.loop,
          autoplay: props.autoplay, // usually false; we control play via visibility
          path: props.src,
        });
      }
      if (anim) visible ? anim.play?.() : anim.pause?.();
    },
    { immediate: true }
  );
});

onBeforeUnmount(() => anim?.destroy?.());
</script>

<template>
  <ClientOnly>
    <div ref="container"></div>
  </ClientOnly>
</template>
